import * as Fetch from '@/helpers/fetch'

export const getCouponsByType = async (token: string, type: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_MY_COUPON_SERVICE_URL}/v2/customers/me/coupons?type=${type}`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      channel: 'line',
      'Accept-Language': 'th'
    }
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
